import { AdminAppConfig, CaptchaVersionConfig, PaymentMessagesConfig } from '.';
import { EntityName, PaymentMethods, PaymentMethodsExtend, PlatformID } from '..';
import { OverrideEnumArray, OverrideMapObject } from '../../../../decorators';

export class DefaultAppConfig implements AdminAppConfig {
    id = '';
    isMaintenanceModeEnabled = false;
    documentTypeLookup = {
        passport: '',
        national: '',
        driver: '',
        bank: ''
    };
    userIdleTime = 0;
    recaptchaUserIdleTime = 120000;
    usdtWithdrawMin = 0;
    isLegalModalEnabled = false;
    @OverrideEnumArray(EntityName)
    availableEntities;
    customerSupport = {
        asic: {
            email: '',
            phone: ''
        },
        cysec: {
            email: '',
            phone: ''
        },
        fca: {
            email: '',
            phone: ''
        },
        scb: {
            email: '',
            phone: ''
        },
        svg: {
            email: '',
            phone: ''
        },
        vfsc: {
            email: '',
            phone: ''
        }
    };
    externalLegalDocumentsUrl = '';
    whiteListedRoutes = [''];
    @OverrideEnumArray(PaymentMethods)
    disabledPayments;
    latestOfficalWebsiteLink = '';
    referLink = '';
    isWebtraderEnabled = false;
    roundedCurrencies = [''];
    feature = {
        additionalTradingAccount: {
            enabled: true
        },
        // @Thanh remove this config once the Monorepo is on prod
        calculatorTools: {
            enabled: true
        },
        tradingTools: {
            calculator: {
                enabled: true
            },
            capitalise: {
                enabled: true,
                learnMore: 'https://www.eightcap.com/en/trading-platforms/tools/capitalise/',
                connectAccount: 'https://eightcap.capitalise.ai/account/signin'
            },
            bk_CryptoCrusher: {
                enabled: true,
                learnMore: 'https://bkcryptocrusher.com/',
                connectAccount:
                    'https://bkcryptocrusher.com/member-verification/?sp=non_members_error_page&pid=15&wlfrom=%2Fdashboard%2F'
            },
            tradingViewTools: {
                enabled: true,
                learnMore: 'https://portal.eightcap.com/en-US/trading-account'
            }
        },
        contest: {
            enabled: false
        },
        education: {
            enabled: false,
            howToTradeLink: ''
        },
        payment: {
            checkActiveGatewayPlatforms: ['']
        },
        recaptcha: {
            recaptchav2: new CaptchaVersionConfig(),
            recaptchav3: new CaptchaVersionConfig(),
            recaptchaBaseUrl: '',
            recaptchaRefreshInterval: 90000
        },
        registerPartner: {
            enabled: true
        },
        referAFriend: {
            enabled: false,
            shareLink: '',
            allowEntities: []
        },
        scbLeverage: {
            enabled: false,
            threshold: 200
        },
        signup: {
            cysecPercentage: '60.22%'
        },
        tradingViewTools: {
            enabled: false
        },
        upgradeToPro: {
            enabled: true,
            mentorEducationLink: '',
            allowTenants: ['']
        },
        paymentMessages: {
            enabled: true,
            messages: [new PaymentMessagesConfig()]
        }
    };
    enableRegisterPartner = false;
    @OverrideEnumArray(PaymentMethodsExtend)
    enabledPaymentDialog;
    legaldocuments = {
        scb: {
            ppa: '',
            cap: '',
            rdp: '',
            pds: '',
            fsg: '',
            ltg: '',
            fk: '',
            rewards: '',
            tac: '',
            ra: '',
            uhb: ''
        },
        svg: {
            ppa: '',
            cap: '',
            rdp: '',
            pds: '',
            fsg: '',
            ltg: '',
            fk: '',
            rewards: '',
            tac: '',
            ra: '',
            uhb: ''
        },
        vfsc: {
            ppa: '',
            cap: '',
            rdp: '',
            pds: '',
            fsg: '',
            ltg: '',
            fk: '',
            rewards: '',
            tac: '',
            ra: '',
            uhb: ''
        }
    };
    legalDocumentBaseUrl = '';
    @OverrideEnumArray(PlatformID)
    paymentUserCountryCheckOnly;
    countriesForLatinBankWithdrawal = [''];
    showWithdrawMaintenanceMessage = false;
    restrictCountryEnabled = true;
    @OverrideMapObject({ key: { label: 'Payment Method' }, value: { label: 'Gateway ID' } })
    mapPaymentToGateway;
    maxFileUploadSize = 3145728;
    registerPartnerUrl = '';
    enableMypayAlternateGatewayConfig = false;
    enableEURedirectLink = false;
}
